var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiQuora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1603_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3687 23.3925C15.33 21.3469 14.1112 19.2806 11.7319 19.2806C11.2781 19.2806 10.8244 19.3556 10.4062 19.5469L9.6 17.9288C10.5844 17.085 12.1744 16.4137 14.22 16.4137C17.4019 16.4137 19.035 17.9475 20.3325 19.9013C21.1012 18.2325 21.4669 15.9769 21.4669 13.1813C21.4669 6.19875 19.2825 2.61375 14.1825 2.61375C9.1575 2.61375 6.98438 6.19875 6.98438 13.1813C6.98438 20.1263 9.1575 23.6737 14.1844 23.6737C14.9812 23.6737 15.705 23.5875 16.3706 23.3925H16.3687ZM17.6156 25.83C16.4971 26.1333 15.3433 26.2872 14.1844 26.2875C7.48875 26.2875 0.9375 20.9475 0.9375 13.1813C0.9375 5.34188 7.49063 0 14.1825 0C20.9888 0 27.4762 5.3025 27.4762 13.1813C27.4762 17.5631 25.4325 21.1238 22.4606 23.4263C23.4206 24.8644 24.4106 25.8206 25.785 25.8206C27.2887 25.8206 27.8944 24.6581 27.9956 23.7488H29.9513C30.0656 24.9619 29.46 30 23.9925 30C20.6794 30 18.9281 28.08 17.6156 25.83Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1603_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiQuora);
export default __webpack_public_path__ + "static/media/bi_quora.387324ca54c63bb34729a965c12e603d.svg";
export { ForwardRef as ReactComponent };